import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
import _imports_0 from '@/assets/componentImg/channel/photo_icon.png';

const _withScopeId = n => (_pushScopeId("data-v-3db77e31"), n = n(), _popScopeId(), n);

const _hoisted_1 = {
  key: 0,
  class: "right"
};
const _hoisted_2 = {
  key: 1,
  class: "count-tips"
};

const _hoisted_3 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: ""
}, null, -1));

import composition from '@/composition';
export default {
  props: {
    images: Array
  },

  setup(__props) {
    const props = __props;
    const {
      ref
    } = composition();
    const imgClass = ref('');

    if (props.images.length == 1) {
      imgClass.value = 'one-img-wrap';
    } else if (props.images.length == 2) {
      imgClass.value = 'two-img-wrap';
    } else if (props.images.length > 2) {
      imgClass.value = 'three-img-wrap';
    }

    return (_ctx, _cache) => {
      const _component_van_image = _resolveComponent("van-image");

      return _openBlock(), _createElementBlock("div", {
        class: _normalizeClass(['img-wrap', imgClass.value])
      }, [_createVNode(_component_van_image, {
        class: "img img-0",
        src: __props.images[0].filePath,
        fit: "cover"
      }, null, 8, ["src"]), __props.images.length > 1 ? (_openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_van_image, {
        class: "img",
        src: __props.images[1].filePath,
        fit: "cover"
      }, null, 8, ["src"]), __props.images.length > 2 ? (_openBlock(), _createBlock(_component_van_image, {
        key: 0,
        class: "img",
        src: __props.images[2].filePath,
        fit: "cover"
      }, null, 8, ["src"])) : _createCommentVNode("", true), __props.images.length > 3 ? (_openBlock(), _createElementBlock("div", _hoisted_2, [_hoisted_3, _createElementVNode("span", null, _toDisplayString(__props.images.length), 1)])) : _createCommentVNode("", true)])) : _createCommentVNode("", true)], 2);
    };
  }

};